import { styled } from "@mui/material";
import { TableContainer as MuiTableContainer } from "@mui/material";

export const TableContainer = styled(MuiTableContainer)({
  display: "flex",
  flexDirection: "column",
  flex: "1 1 0",
  overflow: "auto",
  border: "1px solid #E0E0E0",
});
